import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DeploymentDialogComponent } from './deployment-dialog/deployment-dialog.component';
import { DeploymentWizardWindowService } from './deployment-wizard-window.service';
import { DeploymentProcessService } from './deployment-process.service';
import { AppState } from '../model/reducer';
import { Store } from '@ngrx/store';
import { StoreDeploymentWizardWindowState } from '../model/deploy';

@Component({
    selector: 'adm4-deployment-wizard-main',
    template: '',
    standalone: false
})
export class DeploymentWizardMainComponent implements OnInit, OnDestroy {
  private deploymentWizardWindowService = inject(DeploymentWizardWindowService);
  private deploymentProcessService = inject(DeploymentProcessService);
  private store$ = inject<Store<AppState>>(Store);


  dialogRef: MatDialogRef<DeploymentDialogComponent>;

  ngOnInit(): void {
    setTimeout(() => {
      this.dialogRef = this.deploymentWizardWindowService.openDeploymentWizard();
      this.store$.dispatch(new StoreDeploymentWizardWindowState(true));
    });
  }

  ngOnDestroy(): void {
    this.dialogRef.afterClosed().subscribe(() => {
      this.store$.dispatch(new StoreDeploymentWizardWindowState(false));
      this.deploymentProcessService.clearDeployProcess();
    });
    this.dialogRef.close();
  }

}
